import { $language } from '@/stores/Language'

// Map short language codes to proper Intl locale codes
const localeMap: Record<string, string> = {
  en: 'en-US',
  de: 'de-DE',
  fr: 'fr-FR',
  cn: 'zh-CN',
  ja: 'ja-JP',
  pl: 'pl-PL',
}

const getLocale = () => localeMap[$language.get()] || 'en-US'

const priceFormatter = (amount: number | string, currency?: string | null) => new Intl.NumberFormat(getLocale(), {
  style: 'currency',
  currency: currency ?? 'USD',
  currencyDisplay: 'symbol',
  maximumFractionDigits: 2,
}).format(
  Number.parseFloat(amount.toString()),
)

export {
  priceFormatter,
}
